import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-crown",
  "use": "icon-crown-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-crown\"><path d=\"M213.333333 682.666667L128 213.333333l234.666667 298.666667L512 213.333333l149.333333 298.666667L896 213.333333l-85.333333 469.333334H213.333333m597.333334 128a42.666667 42.666667 0 0 1-42.666667 42.666666H256a42.666667 42.666667 0 0 1-42.666667-42.666666v-42.666667h597.333334v42.666667z\" fill=\"\" p-id=\"5115\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol